// extracted by mini-css-extract-plugin
export default {"container":"kXLAOl6jnhCDZ6XM_NOP","headline":"IAm7_WreUp_84ynGoQbF","price":"XRA0zoPxRCsKmGzIrEO9","text":"MQAjPGzjzzw6UvtLEA6V","link":"GrnEAz398gl0ipx1XbhR"};